// extracted by mini-css-extract-plugin
export default {"container":"adminPanel_container__NE0mH","toolsContainer":"adminPanel_toolsContainer__Pp9gT","toolCard":"adminPanel_toolCard__GqcLb","logoutButton":"adminPanel_logoutButton__V0sJM"};